import { render, staticRenderFns } from "./EmpresaSelector.vue?vue&type=template&id=1f2cd94a&scoped=true"
import script from "./EmpresaSelector.vue?vue&type=script&lang=js"
export * from "./EmpresaSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2cd94a",
  null
  
)

export default component.exports